export const modeOptions = [
    { label: 'Mode: Standby/Fault', value: 'StandbyFaultMode', color: '#219ebc' },
    { label: 'Mode: Inverter', value: 'InverterMode', color: '#219ebc' },
    { label: 'Mode: Charger', value: 'ChargerMode', color: '#219ebc' },
    { label: 'Mode: Power Saving', value: 'PowerSavingMode', color: '#219ebc' },
];

export const chargeStageOptions = [
    { label: 'Stage: Standby', value: 'StandbyStage', color: '#023047' },
    { label: 'Stage: Bulk Current', value: 'BulkCurrentStage', color: '#023047' },
    { label: 'Stage: Absorb Voltage', value: 'AbsorbVoltageStage', color: '#023047' },
    { label: 'Stage: Equalization', value: 'EqualizationStage', color: '#023047' },
    { label: 'Stage: Floating Voltage', value: 'FloatingVoltageStage', color: '#023047' },
    { label: 'Stage: Charger Off', value: 'ChargerOffStage', color: '#023047' },
];

export const generatorStatusOptions = [
    { label: 'Generator: Under Frequency', value: 'UnderFrequencyGeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Over Frequency', value: 'OverFrequencyGeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Phase Lock Failure', value: 'PhaseLockFailureGeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Under Voltage 1', value: 'UnderVoltage1GeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Under Voltage 2', value: 'UnderVoltage2GeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Under Voltage 3', value: 'UnderVoltage3GeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Over Voltage 1', value: 'OverVoltage1GeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Over Voltage 1', value: 'OverVoltage2GeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Over Voltage 1', value: 'OverVoltage3GeneratorStatus', color: '#fb8500' },
    { label: 'Generator: No VAC Input', value: 'NoVACInputGeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Input over Current', value: 'InputOverCurrentGeneratorStatus', color: '#fb8500' },
    { label: 'Generator: Phase Unlocked', value: 'PhaseUnlockedGeneratorStatus', color: '#fb8500' },
];

export const acStatusOptions = [
    { label: 'AC: Under Frequency', value: 'UnderFrequencyAcStatus', color: '#540b0e' },
    { label: 'AC: Over Frequency', value: 'OverFrequencyAcStatus', color: '#540b0e' },
    { label: 'AC: Phase Lock Failure', value: 'PhaseLockFailureAcStatus', color: '#540b0e' },
    { label: 'AC: Under Voltage 1', value: 'UnderVoltage1AcStatus', color: '#540b0e' },
    { label: 'AC: Under Voltage 2', value: 'UnderVoltage2AcStatus', color: '#540b0e' },
    { label: 'AC: Under Voltage 3', value: 'UnderVoltage3AcStatus', color: '#540b0e' },
    { label: 'AC: Over Voltage 1', value: 'OverVoltage1AcStatus', color: '#540b0e' },
    { label: 'AC: Over Voltage 1', value: 'OverVoltage2AcStatus', color: '#540b0e' },
    { label: 'AC: Over Voltage 1', value: 'OverVoltage3AcStatus', color: '#540b0e' },
    { label: 'AC: No VAC Input', value: 'NoVACInputAcStatus', color: '#540b0e' },
    { label: 'AC: Input over Current', value: 'InputOverCurrentAcStatus', color: '#540b0e' },
    { label: 'AC: Phase Unlocked', value: 'PhaseUnlockedAcStatus', color: '#540b0e' },
];

export const errorCodeOptions = [
    { label: 'Error: Battery under Voltage', value: 'BatteryUnderVoltageErrorCode', color: '#c1121f' },
    { label: 'Error: Battery over Voltage', value: 'BatteryOverVoltageErrorCode', color: '#c1121f' },
    { label: 'Error: Battery ultra-low Voltage', value: 'BatteryUltraLowVoltageErrorCode', color: '#c1121f' },
    { label: 'Error: Input over Current', value: 'InputOverCurrentErrorCode', color: '#c1121f' },
    { label: 'Error: Output over Current', value: 'OutputOverCurrentErrorCode', color: '#c1121f' },
    { label: 'Error: Output over Load', value: 'OutputOverLoadErrorCode', color: '#c1121f' },
    { label: 'Error: Transformer over Heat', value: 'TransformerOverHeatErrorCode', color: '#c1121f' },
    { label: 'Error: Heat Sink over Heat 1', value: 'HeatSinkOverHeat1ErrorCode', color: '#c1121f' },
    { label: 'Error: Output Failure', value: 'OutputFailureErrorCode', color: '#c1121f' },
    { label: 'Error: Output over Load 1', value: 'OutputOverLoad1ErrorCode', color: '#c1121f' },
    { label: 'Error: Output over Load 2', value: 'OutputOverLoad2ErrorCode', color: '#c1121f' },
    { label: 'Error: Output over Load 3', value: 'OutputOverLoad3ErrorCode', color: '#c1121f' },
    { label: 'Error: Output over Load 4', value: 'OutputOverLoad4ErrorCode', color: '#c1121f' },
    { label: 'Error: Battery High Voltage Cut Off', value: 'BatteryHighVoltageCutOffErrorCode', color: '#c1121f' },
    { label: 'Error: Stop Output', value: 'StopOutputErrorCode', color: '#c1121f' },
];

export const groupedOptions = [
    {
        label: 'Mode Options',
        options: modeOptions,
    },
    {
        label: 'Charge Options',
        options: chargeStageOptions,
    },
    {
        label: 'Generator Status Options',
        options: generatorStatusOptions,
    },
    {
        label: 'AC Status Options',
        options: acStatusOptions,
    },
    {
        label: 'Error Code Options',
        options: errorCodeOptions,
    },
];
